export default __webpack_public_path__ + "static/media/save-tick.86f6cb12.svg";